module.exports = __webpack_public_path__ + "static/preview-3773cb69b4013b2209b24a4fda014514.gif";